import { BitrixVue } from "ui.vue3";
import { store } from "./store/global.store";
import { UserAcceptCompanyInviteComponent } from "./components/UserAcceptCompanyInviteComponent/UserAcceptCompanyInviteComponent";

export class UserAcceptCompanyInviteWidget {
	#application;
	/**
	 *
	 * @param {HTMLElement|string} rootNode
	 * @param {Object} options
	 * @param {Object} options.request
	 * @param {String} options.request.component - Название компонента
	 * @param {String} options.request.action - Название экшена
	 */
	constructor(rootNode, options = {}) {
		this.rootNode =
			rootNode instanceof HTMLElement
				? rootNode
				: document.querySelector(rootNode);
		this.options = options;
		this.attachTemplate();
	}
	attachTemplate() {
		const context = this;
		store.dispatch("setGlobalParams", context.options);

		this.#application = BitrixVue.createApp({
			name: "UserAcceptCompanyInviteWidget",
			beforeCreate() {
				this.$bitrix.Application.set(context);
			},
			components: {
				UserAcceptCompanyInviteComponent,
			},
			template: `<UserAcceptCompanyInviteComponent/>`,
		});
		this.#application.use(store);
		this.#application.mount(this.rootNode);
	}
}
